module.exports = __webpack_public_path__ + "img/pontianak.85b314f5.png";